/**
 * @generated SignedSource<<6debf67414dad45f40012c8f3090a049>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskDurationChipSubscription$variables = {
  taskID: string;
};
export type TaskDurationChipSubscription$data = {
  readonly task: {
    readonly " $fragmentSpreads": FragmentRefs<"TaskDurationChip_task">;
  } | null;
};
export type TaskDurationChipSubscription = {
  response: TaskDurationChipSubscription$data;
  variables: TaskDurationChipSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "taskID"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskDurationChipSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TaskDurationChip_task"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskDurationChipSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creationTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "executingTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "durationInSeconds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0bd6bbe06df6a51e128c183b780a7c6f",
    "id": null,
    "metadata": {},
    "name": "TaskDurationChipSubscription",
    "operationKind": "subscription",
    "text": "subscription TaskDurationChipSubscription(\n  $taskID: ID!\n) {\n  task(id: $taskID) {\n    ...TaskDurationChip_task\n    id\n  }\n}\n\nfragment TaskDurationChip_task on Task {\n  id\n  status\n  creationTimestamp\n  scheduledTimestamp\n  executingTimestamp\n  durationInSeconds\n}\n"
  }
};
})();

(node as any).hash = "5c46035ee019d44c31f3cdc44a76f26e";

export default node;
